import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2b21b354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-main cm-align-center" }
const _hoisted_2 = {
  class: "cm-align-center",
  style: {"align-self":"flex-start"}
}
const _hoisted_3 = {
  key: 0,
  class: "cm-ui-ml10"
}
const _hoisted_4 = { style: {"color":"gray"} }
const _hoisted_5 = {
  key: 1,
  class: "cm-ui-ml15",
  style: {"color":"gray"}
}
const _hoisted_6 = { key: 1 }

import CmTable from '@/components/cmTable/index.vue'
import CmForm from '@/components/cmForm/index.vue'
import { nextTick, reactive, ref, watch, computed } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { TableOpt } from '@/components/cmTable/types'
import { FormActionType, FormSize, FormSizeType } from '@/components/cmForm/types'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { LastCommandTaskData, ProcessListData, ResponseHandlingService } from '../service'
import { ElMessageBox, ElMessage } from 'element-plus'
import { formatTimeStamp } from '@/utils/time'
import { bytesToSize, formatWindowsFileTime } from '@/utils/tool'
import dayjs from 'dayjs'
import { getStatusColor, getStatusTitle as getStatusTitleI18n } from '@/services/parse-status.service'
import { PolicyCommonService } from '@/views/dashboard/policy/policy-common.service'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { DEFAULT_SETTING } from '@/views/dashboard/policy/software-disabled-edit/software-disabled-edit.service'
import { login_status } from '../types'
import { useI18n } from 'vue-i18n'
import { listCol } from '@/utils/list-columns-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessInfo',
  props: {
  deviceId: {
    type: String,
  },
  info: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {

const { t, locale } = useI18n()
function getStatusTitle (score: number | string) {
  void locale.value
  return getStatusTitleI18n(score, t)
}
const props = __props
const injector = useReflectiveInjector([ResponseHandlingService, PolicyCommonService])
const service = injector.get(ResponseHandlingService)
const policyService = injector.get(PolicyCommonService)
const api = service.getTerminalProcessList.bind(service)
const closeApi = service.getTerminalOrderCloseProcess.bind(service)
const infoApi = service.getTerminalOrderGetProcessInfo.bind(service)
// 是否已加载数据的标志
const hasLoadedData = ref(false)

const rowOpt = reactive({
  justify: 'end',
})
const btnOpt = { size: FormSize.Small, text: true, type: 'text' }
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const formType = ref(FormActionType.Other)
const formSize: FormSizeType = FormSize.Small
const queryForm = reactive({ device_id: props.deviceId })
const queryFormColumns = computed(() => ({
  key_word: {
    colOpt: { lg: 6, sm: { span: 1 }, style: 'flex: 1 1 150px' },
    hiddenAllLabel: true,
    placeholder: t('responseHandle.processNameDescPlaceholder'),
    modelModifiers: { trim: true },
    inputOpt: {
      'suffix-icon': 'el-icon-search',
    },
    events: {
      blur: () => {
        if (hasLoadedData.value) {
          void refreshList()
        }
      },
      keypress: (e) => {
        if (e.charCode === 13 && hasLoadedData.value) {
          void refreshList()
        }
      },
    },
  },
}))
//
const tableActOpt3 = computed(() => ({
  operateDropdownTitle: t('responseHandle.moreActions'),
  columnOpt: { label: listCol(t, 'operation'), width: 180, align: 'left', fixed: 'right' },
  actionButtons: (row) => [
    {
      name: t('responseHandle.endProcess'), opt: btnOpt,
      events: {
        click() {
          closeProcess(row)
        }
      }
    },
    {
      name: t('responseHandle.blockStart'), opt: btnOpt,
      events: {
        click() {
          stopProcess(row)
        }
      }
    },
  ],
}))

const tableOpt3 = computed<TableOpt>(() => ({
  loadMoreMode: true,
  bodyStyle: 'background: transparent;padding: 0 16px 16px;',
  containerOpt: { style: 'padding: 0;background: var(--cm-color-card-bg)' },
  'max-height': '600px',
  path: 'data',
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  rowKey: 'pid',
  selection: false,
  columns: [
    { label: t('responseHandle.processName'), prop: 'process_name', width: 180 },
    { label: t('responseHandle.threatStatus'), prop: 'kscore', width: 200 },
    { label: t('responseHandle.path'), prop: 'path', width: 300, type: 'PATH' },
    { label: t('responseHandle.description'), prop: 'description', width: 300, showOverflow: true },
    { label: t('responseHandle.cpuUsage'), prop: 'cpu_usage', formatter: (_row, val: any) => parseFloat(String(val * 100)).toFixed(2) + '%' },
    { label: t('responseHandle.memoryUsage'), prop: 'memory_usage', formatter: (_row, value) => bytesToSize(Number.parseInt(String(value || 0))) },
    { label: 'PID', prop: 'pid', width: 100 },
    { label: t('responseHandle.username'), prop: 'username', width: 220 },
    { label: t('responseHandle.fileMd5'), prop: 'file_md5', width: 300, type: "MD5" },
    { label: t('responseHandle.digitalSignature'), prop: 'digital_signature', width: 260 },
    { label: listCol(t, 'createTime'), prop: 'process_create_time', width: 150, formatter: (_, val) => formatWindowsFileTime(val) },
  ],
}))
const loading = ref(false)
const lastResult = ref<Partial<LastCommandTaskData>>({})

// 获取数据的处理函数
const handleGetData = async () => {
  loading.value = true
  try {
    hasLoadedData.value = true
    // 等待 nextTick 确保 API 已经更新
    await refreshList()
  } finally {
    loading.value = false
  }
}

// 清空表格数据
const clearTableData = () => {
  try {
    if (tableRef.value?.tableRef) {
      const elTable = tableRef.value.tableRef
      // 清空选中状态
      if (elTable?.clearSelection) {
        elTable.clearSelection()
      }
      // 通过设置 data 数组的 length 为 0 来清空数据
      // 这是 Vue 响应式系统支持的方式
      if (elTable?.data && Array.isArray(elTable.data)) {
        elTable.data.length = 0
      }
    }
    // 重置总数（如果 CmTable 暴露了 total）
    if (tableRef.value?.total !== undefined) {
      tableRef.value.total = 0
    }
  } catch (error) {
    console.warn('清空表格数据失败:', error)
  }
}

const refresh = async () => {
  loading.value = true
  try {
    // 在调用 getLastInfo 前清空表格数据
    const result = await infoApi({ execute_type: 0, device_list: [props.deviceId] }).catch(err => err)
    await getLastInfo()
    if (result?.responseBody?.ret === 4931001 || [0,1].includes(lastResult.value.status)) {
      return ElMessage.success(t('responseHandle.taskSendingWait'))
    }
    ElMessage.success(t('responseHandle.commandSentListUpdate'))
  } finally {
    loading.value = false
  }
}
const getLastInfo = async () => {
  // 在调用 getLastInfo 前清空表格数据
  const result = await service.getCommandserverGetLastCommandTask({ device_list: [props.deviceId], command_id: 34 })
  hasLoadedData.value = !!result?.data?.length
  await nextTick()
  clearTableData()
  if (hasLoadedData.value) {
    tableRef?.value?.getList?.()
    lastResult.value = result?.data?.[0] || {}
  }
}
const closeProcess = (row: ProcessListData) => {
  const msg = t('responseHandle.confirmEndProcess', { name: `<span style='color: var(--cm-color-text-primary);font-size: 16px;font-weight: 700;'>${row.process_name}</span>` })
  ElMessageBox.confirm(`<div><strong>${msg}</strong></div>`, t('responseHandle.tip'), { dangerouslyUseHTMLString: true }).then(async () => {
    await closeApi({ device_id: props.deviceId, process_name: row.process_name, process_create_time: row.process_create_time, pid: row.pid })
    ElMessage.success(t('responseHandle.opSuccess'))
    void refreshList()
  })
}
const stopProcess = (row: ProcessListData) => {
  const descHtml = `${t('responseHandle.confirmSoftwareDisabledProcessDesc')} <a style="color: var(--el-color-primary)" href="/dashboard/software-disabled">${t('responseHandle.softwareDisabledNavLink')}</a>${t('responseHandle.confirmSoftwareDisabledProcessSuffix')}`
  const msg = t('responseHandle.confirmSoftwareDisabledProcess', { name: `<span style='color: var(--cm-color-text-primary);font-size: 16px;font-weight: 700;margin: 0 4px'>${row.process_name}</span>` })
  const strategy = JSON.stringify({
    ...DEFAULT_SETTING,
    process_infos: [{
      name: String(row.process_name ?? ''),
      path: String(row.path ?? ''),
      md5: String(row.file_md5 ?? ''),
      signature: String(row.digital_signature ?? ''),
    }],
  })
  ElMessageBox.confirm(`<div><strong>${msg}</strong><div style='margin-top: 10px;color: gray;font-size: 14px'>${descHtml}</div></div>`, t('responseHandle.tip'), { dangerouslyUseHTMLString: true }).then(async () => {
    return await policyService.saveSettings({
      id: undefined,
      strategy,
      name: `${t('menu.softwareDisabled')}-${row.process_name}_${row.pid}`,
      group_ids: [],
      device_ids: props.deviceId ? [props.deviceId] : [],
      bind_mode: 1,
      type: PolicySettingType.softwareDisabled,
      strategy_type: PolicyType.softwareDisabled,
    })
  }).then(() => {
    ElMessage.success(t('responseHandle.saveSuccess'))
  }).catch(() => { })
}
watch(() => props.deviceId, async (nv, lv) => {
  if (nv && nv !== lv) {
    queryForm.device_id = nv
    hasLoadedData.value = false
    getLastInfo()
  }
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CmTable, {
    tableOpt: tableOpt3.value,
    modelValue: queryForm,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm) = $event)),
    formType: formType.value,
    "onUpdate:formType": _cache[3] || (_cache[3] = ($event: any) => ((formType).value = $event)),
    api: _unref(api),
    formColumns: queryFormColumns.value,
    tableActOpt: tableActOpt3.value,
    "first-loading": false,
    ref_key: "tableRef",
    ref: tableRef,
    pageOption: {
      style: 'padding-bottom: 16px', pageNumName: 'page', pageSizeName: 'limit',
    }
  }, {
    header: _withCtx(({ rowData }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            size: _unref(formSize),
            onClick: refresh,
            type: "primary",
            plain: "",
            loading: loading.value,
            disabled: __props.info.login_status !== _unref(login_status).online
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.refresh')), 1)
            ]),
            _: 1
          }, 8, ["size", "loading", "disabled"]),
          (!hasLoadedData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('responseHandle.noDataYetManual')), 1),
                _createVNode(_component_el_button, {
                  type: "text",
                  loading: loading.value,
                  onClick: handleGetData
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.getLatestData')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
            : _createCommentVNode("", true),
          (lastResult.value.create_time)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('responseHandle.lastGetDataTime')) + _toDisplayString(_unref(dayjs)(Number(lastResult.value.create_time) *
              1000).format('YYYY-MM-DD HH:mm')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(CmForm, {
          formSize: _unref(formSize),
          style: {"flex":"1"},
          modelValue: queryForm,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm) = $event)),
          formType: formType.value,
          "onUpdate:formType": _cache[1] || (_cache[1] = ($event: any) => ((formType).value = $event)),
          formColumns: queryFormColumns.value,
          rowOpt: rowOpt
        }, null, 8, ["formSize", "modelValue", "formType", "formColumns", "rowOpt"])
      ])
    ]),
    kscore: _withCtx((slotProps) => [
      (slotProps.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cm-score-tag",
            style: _normalizeStyle(`background: ${_unref(getStatusColor)(slotProps.value)}`)
          }, _toDisplayString(getStatusTitle(slotProps.value)), 5))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))
    ]),
    _: 1
  }, 8, ["tableOpt", "modelValue", "formType", "api", "formColumns", "tableActOpt"]))
}
}

})